import './setup-libphonenumber-global.js';
import '../../wwwroot/js/app.js';
import '../../wwwroot/js/form-submit-state.js';
import '../../wwwroot/js/public-form-validation.js';
import '../../wwwroot/js/ajax-form-runtime.js';
import '../../wwwroot/js/callback-modal.js';
import '../../wwwroot/js/callback-form.js';
import '../../wwwroot/js/general-form.js';
import '../../wwwroot/js/file-dropzone.js';
import '../../wwwroot/js/phone-formatter.js';
import '../../wwwroot/js/newsletter.js';
import '../../wwwroot/js/blocks/cookie-consent.js';
import '../../wwwroot/js/blocks/ui-components.js';
import '../../wwwroot/js/blocks/notifications.js';
import '../../wwwroot/js/blocks/lqip.js';
import '../../wwwroot/js/blocks/hero-slider.js';
import '../../wwwroot/js/blocks/hero-section.js';
import '../../wwwroot/js/blocks/main-navigation.js';
import '../../wwwroot/js/blocks/product-gallery.js';
import '../../wwwroot/js/blocks/product-configuration-switcher.js';
import '../../wwwroot/js/blocks/product-tab-menu.js';
import '../../wwwroot/js/blocks/catalog-results-switcher.js';
import '../../wwwroot/js/blocks/blog-load-more.js';
import '../../wwwroot/js/blocks/payment-calculator.js';
